<template>
    <div class="basic-setting-content pl16 pr16">

        <el-form-item label="店铺名称" :rules="[{required: true,message: '请输入店铺名称'}]">
            <el-input v-model="formData.name" placeholder="请输入店铺名称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :rules="[{required: true,message: '请输入联系人'}]">
            <el-input v-model="formData.link_name" placeholder="请输入联系人" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :rules="[{required: true,message: '请输入联系电话'}]">
            <el-input v-model="formData.link_phone" placeholder="请输入联系电话" class="max-w460" v-bind:readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" :rules="[{required: true,message: '请输入联系地址'}]">
            <el-input v-model="formData.address" placeholder="请输入联系地址" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商家介绍" :rules="[{required: true,message: '请输入商家介绍'}]">
            <el-input type="textarea" v-model="formData.description" placeholder="请输入商家介绍" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="店铺logo" :rules="[{required: true,message: '选择Logo'}]">
            <el-button @click="chooseImg('logo')">选择Logo</el-button>
            <div v-if="formData.logo_id!=''" class="img">
                <img :src="formData.logo.file_path" width="100" height="100"/>
            </div>
        </el-form-item>

        <!--上传图片-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>
    </div>
</template>

<script>
    import Upload from '@/components/file/Upload';

    export default {
        components: {
            Upload,
        },
        data() {
            return {
                // 是否打开图片选择
                isupload: false,
                // 当前图片类别
                type: null,
                logo_file_path: '',
                business_file_path: '',
            }
        },
        inject: ['formData'],
        watch: {

        },
        created() {

        },
        methods: {
            // 选择图片
            chooseImg(e) {
                this.type = e;
                this.isupload = true;
            },

            // 关闭选择图片
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    if (this.type == 'logo') {
                        this.logo_file_path = e[0].file_path;
                        this.formData.logo_id = e[0].file_id;
                    } else if (this.type == 'business') {
                        this.business_file_path = e[0].file_path;
                        this.formData.business_id = e[0].file_id;
                    }
                }
                this.isupload = false;
            }
        }
    }
</script>

<style scoped>
    .img{
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/supplier/part/Basic.vue